import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react'
import {
  Form,
  FormField,
  Message,
  Button,
  Tab,
  Divider,
  Menu,
  Grid,
  Modal,
  Icon,
} from 'semantic-ui-react'
// import Swal from 'sweetalert2'
// import { yupResolver } from '@hookform/resolvers/yup'
// import * as yup from 'yup'
import { useSelector } from 'react-redux'
import styles from './device-view.module.css'
import DeviceActions from './device-actions'
import IntelMsg from '../../../ItelMsg'
import {
  ConfigureDevice,
  GetDeviceInfo,
  SendCommandDevice,
  SendCommandDeviceFromTroubleShoot,
} from '../../../../services/device-page-list'

export const DeviceViewContext = createContext()
const panes = [
  {
    menuItem: (
      <Menu.Item className={styles.tabs}>Device Troubleshoot</Menu.Item>
    ),
    render: () => (
      <Tab.Pane>
        <DeviceView />
      </Tab.Pane>
    ),
  },
  {
    menuItem: <Menu.Item className={styles.tabs}>Send Command</Menu.Item>,
    render: () => (
      <Tab.Pane>
        <SendCommand />
      </Tab.Pane>
    ),
  },
  {
    menuItem: <Menu.Item className={styles.tabs}>Force Send Command</Menu.Item>,
    render: () => (
      <Tab.Pane>
        <ForceSendCommand />
      </Tab.Pane>
    ),
  },
  {
    menuItem: (
      <Menu.Item className={styles.tabs}>Manual Configuration</Menu.Item>
    ),
    render: () => (
      <Tab.Pane>
        <ManualConfiguration />
      </Tab.Pane>
    ),
  },
]

const Troubleshoot = () => (
  <div>
    <Divider hidden />
    <Tab
      className={styles.wrapped}
      menu={{
        attached: false,
        inverted: false,
        pointing: true,
      }}
      panes={panes}
    />
  </div>
)

const DeviceView = () => {
  const { setViewDevice } = useContext(DeviceViewContext)
  const [deviceName, setDeviceName] = useState('')
  const [simNo, setSimNo] = useState('')
  const [IMSI, setIMSI] = useState('')
  const [height, setHeight] = useState('')
  const [settings, setSettings] = useState('')

  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))
  console.log('device dataaaaaa: ', deviceData)

  useEffect(() => {
    GetDeviceInfo(deviceData['device id']).then((data) => {
      console.log('my data: ', data)
      setSimNo(data.simNumber)
      setIMSI(data.imsi)
      setHeight(data.height)
      setSettings(data.settings)
      setDeviceName(deviceData['device label'])
    })
  }, [])
  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="Device Troubleshoot" />
      </div>{' '}
      <br />
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
      >
        <Form.Field>
          <b style={{ color: 'black' }}>Device Name:</b>
          <span>
            <Message content={deviceName || 'Device Name is not provided'} />
          </span>{' '}
        </Form.Field>
        <Form.Field>
          <b style={{ color: 'black' }}>SIM Number:</b>
          <span>
            <Message content={simNo || 'No SIM Number Provided'} />
          </span>
        </Form.Field>
        <Form.Field>
          <b style={{ color: 'black' }}>IMSI:</b>
          <span>
            <Message content={IMSI} />
          </span>
        </Form.Field>
        <Form.Field>
          <b style={{ color: 'black' }}>Height:</b>
          <span>
            <Message content={height} />
          </span>
        </Form.Field>
        <Form.Field className="wrapp">
          <b style={{ color: 'black' }}>Settings:</b>
          <span className="wrapp">
            <Message
              className={styles.wrapp}
              content={settings || 'No Settings Provided'}
            />
          </span>
        </Form.Field>
      </Form>
      <DeviceActions onBackClick={() => setViewDevice(false)} />
    </div>
  )
}

function modalReducer(state, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { open: true, dimmer: action.dimmer }
    case 'CLOSE_MODAL':
      return { open: false }
    default:
      throw new Error()
  }
}
const ForceSendCommand = () => {
  const [state, dispatch] = React.useReducer(modalReducer, {
    open: false,
    dimmer: undefined,
  })
  const { open, dimmer } = state
  const { setViewDevice } = useContext(DeviceViewContext)
  const [inputValue, setInputValue] = useState('')
  // const [visible, setVisibleMsg] = useSstate(false)
  const [copied, setCopied] = useState('')
  const textAreaRef = useRef(null)
  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))

  useEffect(() => {
    setInputValue('3&x!yz,R1=20')
    GetDeviceInfo(deviceData['device id']).then((data) => {
      console.log(data)
    })
  }, [])

  const handleForceSend = () => {
    SendCommandDevice(deviceData['device name'].slice(4), 'R1=20')
      .then(() => {
        console.log(
          'data sent successfully! ',
          'device name : ',
          deviceData['device name'].slice(4),
        )
      })
      .then(dispatch({ type: 'OPEN_MODAL', dimmer: 'blurring' }))
  }
  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="Force Device Send Command" />
      </div>{' '}
      <br />
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
      >
        <FormField inline>
          <input ref={textAreaRef} value={inputValue} placeholder="..." />
          <Button
            size="small"
            primary
            onClick={(e) => {
              if (inputValue !== '') {
                textAreaRef.current.select()
                document.execCommand('copy')
                e.target.focus()
                setCopied(' Copied! ')
              } else setCopied('')
            }}
          >
            Copy
          </Button>
          {copied !== '' ? (
            <Message floating color="green" header="Message Copied!" />
          ) : null}
        </FormField>
        <FormField></FormField>
        <FormField>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                className={styles.button}
                onClick={handleForceSend}
                color="red"
              >
                Send Command
              </Button>
            </Grid.Column>
          </Grid>
        </FormField>
        {/* {visible ? (
          <Message positive onDismiss={handleMSG} header="Message Sent" />
        ) : null} */}
      </Form>
      <DeviceActions onBackClick={() => setViewDevice(false)} />
      <Modal
        dimmer={dimmer}
        open={open}
        onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
      >
        <Modal.Header>Message Sent to Device Successfully!</Modal.Header>
        <Modal.Actions>
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                positive
                onClick={() => dispatch({ type: 'CLOSE_MODAL' })}
              >
                OK
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const SendCommand = () => {
  const [state, dispatch] = React.useReducer(modalReducer, {
    open: false,
    dimmer: undefined,
  })
  const { open, dimmer } = state
  const { setViewDevice } = useContext(DeviceViewContext)
  const [inputValue, setInputValue] = useState('')
  const [generateValue, setGenerateValue] = useState('')
  const [copied, setCopied] = useState('')
  const textAreaRef = useRef(null)
  const [msg, setMsg] = useState('')
  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))

  console.log('device dataaaaaa: ', deviceData['device name'].slice(4))

  const handleMessage = () => {
    if (generateValue && generateValue >= 20 && generateValue <= 300) {
      ConfigureDevice(generateValue).then((data) => {
        setMsg(data.data.message)
        console.log(msg)
        setInputValue(data.data.message)
      })
    } else {
      setMsg('')
      setInputValue('')
      setCopied('')
    }
  }

  const handleSendCommand = () => {
    SendCommandDeviceFromTroubleShoot(
      deviceData['device name'].slice(4),
      inputValue.slice(7),
      generateValue,
      'troubleshoot',
      deviceData['device id'],
    )
      .then(() => {
        SendCommandDevice(deviceData['device name'].slice(4), 'R1=02')
      })
      .then(dispatch({ type: 'OPEN_MODAL', dimmer: 'blurring' }))
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="Device Send Command" />
      </div>{' '}
      <br />
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
      >
        <FormField>
          <Message
            info
            header="Tip:"
            content="Copy the below 1st configuration message and send it to the device SMS, make sure that APN setting are correct. Note: that minimum height is 20 cm and maximum is 300 cm ."
          />
        </FormField>
        <FormField>
          <input
            type="number"
            min="20"
            max="300"
            required
            value={generateValue}
            onChange={(e) => setGenerateValue(e.target.value)}
            placeholder="..."
          />
          <small style={{ color: 'red' }}>**</small>
          <br />
          <Button size="small" primary onClick={handleMessage}>
            Generate
          </Button>
        </FormField>
        <FormField>
          <input ref={textAreaRef} value={inputValue} placeholder="..." />
          <Button
            size="small"
            primary
            onClick={(e) => {
              if (inputValue !== '') {
                textAreaRef.current.select()
                document.execCommand('copy')
                e.target.focus()
                setCopied(' Copied! ')
              } else setCopied('')
            }}
          >
            Copy
          </Button>
          {copied !== '' ? (
            <Message floating color="green" header="Message Copied!" />
          ) : null}
        </FormField>
        <FormField>
          {/* {' '}
          <br /> */}
          <hr />
          <Grid>
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Button
                  className={styles.button}
                  disabled={!inputValue}
                  color="red"
                  onClick={handleSendCommand}
                >
                  Send Command
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </FormField>
      </Form>
      <DeviceActions onBackClick={() => setViewDevice(false)} />
      <Modal
        dimmer={dimmer}
        open={open}
        onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
      >
        <Modal.Header>Message Sent to Device Successfully!</Modal.Header>
        <Modal.Actions>
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                positive
                onClick={() => dispatch({ type: 'CLOSE_MODAL' })}
              >
                OK
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const ManualConfiguration = () => {
  const [state, dispatch] = React.useReducer(modalReducer, {
    open: false,
    dimmer: undefined,
  })
  const { open, dimmer } = state
  const { setViewDevice } = useContext(DeviceViewContext)
  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))
  const [errMsg, setErrMsg] = useState(false)

  const [s0, setS0] = useState('')
  const [s1, setS1] = useState('')
  const [s2, setS2] = useState('')
  const [s3, setS3] = useState('')
  const [s4, setS4] = useState('')
  const [s5, setS5] = useState('')
  const [s6, setS6] = useState('')
  const [s7, setS7] = useState('')
  const [s8, setS8] = useState('')
  const [s9, setS9] = useState('')
  const [s10, setS10] = useState('')
  const [s11, setS11] = useState('')
  const [s12, setS12] = useState('')

  const handleS0 = (str, status) => {
    if (status === true) {
      setS0(str)
    }
  }
  const handleS1 = (str, status) => {
    if (status === true) {
      setS1(str)
    }
  }
  const handleS2 = (str, status) => {
    if (status === true) {
      setS2(str)
    }
  }

  const handleS3 = (str, status) => {
    if (status === true) {
      setS3(str)
    }
  }

  const handleS4 = (str, status) => {
    if (status === true) {
      setS4(str)
    }
  }
  const handleS5 = (str, status) => {
    if (status === true) {
      setS5(str)
    }
  }
  const handleS6 = (str, status) => {
    if (status === true) {
      setS6(str)
    }
  }
  const handleS7 = (str, status) => {
    if (status === true) {
      setS7(str)
    }
  }
  const handleS8 = (str, status) => {
    if (status === true) {
      setS8(str)
    }
  }
  const handleS9 = (str, status) => {
    if (status === true) {
      setS9(str)
    }
  }
  const handleS10 = (str, status) => {
    if (status === true) {
      setS10(str)
    }
  }
  const handleS11 = (str, status) => {
    if (status === true) {
      setS11(str)
    }
  }
  const handleS12 = (str, status) => {
    if (status === true) {
      setS12(str)
    }
  }

  const handleHex = (str) => {
    if (/^[0-9a-f]+$/.test(str) || str === '') {
      return true
    }
    return false
  }

  const handleSubmit = () => {
    const settings = []
    if (s0 !== '') settings.push(`S0=${s0}`)
    if (s1 !== '') settings.push(`S1=${s1}`)
    if (s2 !== '') settings.push(`S2=${s2}`)
    if (s3 !== '') settings.push(`S3=${s3}`)
    if (s4 !== '') settings.push(`S4=${s4}`)
    if (s5 !== '') settings.push(`S5=${s5}`)
    if (s6 !== '') settings.push(`S6=${s6}`)
    if (s7 !== '') settings.push(`S7=${s7}`)
    if (s8 !== '') settings.push(`S8=${s8}`)
    if (s9 !== '') settings.push(`S9=${s9}`)
    if (s10 !== '') settings.push(`S10=${s10}`)
    if (s11 !== '') settings.push(`S11=${s11}`)
    if (s12 !== '') settings.push(`S12=${s12}`)
    console.log(settings.join(','))
    if (
      !s0 &&
      !s1 &&
      !s2 &&
      !s3 &&
      !s4 &&
      !s5 &&
      !s6 &&
      !s7 &&
      !s8 &&
      !s9 &&
      !s10 &&
      !s11 &&
      !s12
    ) {
      setErrMsg(true)
      console.log(errMsg)

      console.log('You should type at least one input')
    } else {
      setErrMsg(false)
      SendCommandDevice(deviceData['device name'].slice(4), settings.join)
        .then((data) => {
          console.log(data)
        })
        .then(dispatch({ type: 'OPEN_MODAL', dimmer: 'blurring' }))
    }
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="Manual Configuration" />
      </div>
      {/* <br /> */}
      <Message warning>
        <Icon name="help circle" size="large"></Icon>
        <span>You must type Hexadecimal values only</span>
      </Message>
      {errMsg ? (
        <Message error>
          <Icon name="warning" size="large"></Icon>
          <span>You should type at least one input</span>
        </Message>
      ) : null}
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        onSubmit={handleSubmit}
      >
        <Grid columns="three" divided>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>S0 (Logger Config):</span>
                <input
                  value={s0}
                  onChange={(e) =>
                    handleS0(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>S1 (GSM Listen Config):</span>
                <input
                  value={s1}
                  onChange={(e) =>
                    handleS1(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S2 (Schedule Configurator):
                </span>
                <input
                  value={s2}
                  onChange={(e) =>
                    handleS2(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S3 (Control Configurator):
                </span>
                <input
                  value={s3}
                  onChange={(e) =>
                    handleS3(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S4 (Static Limit Configurator):
                </span>
                <input
                  value={s4}
                  onChange={(e) =>
                    handleS4(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S5 (Static Limit Configurator):
                </span>
                <input
                  value={s5}
                  onChange={(e) =>
                    handleS5(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S6 (Static Limit Configurator):
                </span>
                <input
                  value={s6}
                  onChange={(e) =>
                    handleS6(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S7 (Dynamic Limit Configurator):
                </span>
                <input
                  value={s7}
                  onChange={(e) =>
                    handleS7(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S8 (Dynamic Limit Configurator):
                </span>
                <input
                  value={s8}
                  onChange={(e) =>
                    handleS8(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S9 (Primary Server SMS Phone Nr. (A20)):
                </span>
                <input
                  value={s9}
                  onChange={(e) =>
                    handleS9(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S10 (Secondary Server SMS Phone Nr. (A20)):
                </span>
                <input
                  value={s10}
                  onChange={(e) =>
                    handleS10(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>
                  S11 (Unit Password (A6)):
                </span>
                <input
                  value={s11}
                  onChange={(e) =>
                    handleS11(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <span style={{ color: 'black' }}>S12 (GPRS APN (A30)):</span>
                <input
                  value={s12}
                  onChange={(e) =>
                    handleS12(e.target.value, handleHex(e.target.value))
                  }
                  placeholder="..."
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br />
        <FormField>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button type="submit" className={styles.button} color="red">
                Submit
              </Button>
            </Grid.Column>
          </Grid>
          <br />
        </FormField>
      </Form>
      <DeviceActions onBackClick={() => setViewDevice(false)} />
      <Modal
        dimmer={dimmer}
        open={open}
        onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
      >
        <Modal.Header>Message Sent to Device Successfully!</Modal.Header>
        <Modal.Actions>
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                positive
                onClick={() => dispatch({ type: 'CLOSE_MODAL' })}
              >
                OK
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default Troubleshoot
